import classnames from 'classnames';
import React from 'react';

import { Icon, IconTypes } from '@eika/icon';

import { SelectPanelItemProps } from '..';

import './SelectPanelItem.scss';

function SelectPanelItem<T>({ value, check, onClick, children, ...rest }: SelectPanelItemProps<T>) {
    return (
        <li {...rest}>
            <button
                type="button"
                role="radio"
                aria-checked={check}
                className={classnames('select-panel-item', { interval: check })}
                onClick={() => onClick(value)}
            >
                <span className="select-panel-item__content">{children}</span>
                {check && <Icon type={IconTypes.CHECKED_24} />}
            </button>
        </li>
    );
}

export default SelectPanelItem;
